import { useDispatch, useSelector } from "react-redux";
import {
  selectBillingTiers,
  setLoadingTiers,
  addAttempt,
  updateTiers,
} from "../State/Slices/BillingTiersSlice";
import { useEffect } from "react";
import { getClientBillingTiers } from "../Services/API/ClientBillingsTier";
import { Dispatch } from "@reduxjs/toolkit";

export async function updateBillingTiersData(dispatch: Dispatch<any>) {
  dispatch(setLoadingTiers(true));
  dispatch(addAttempt(undefined));
  const tiers = await getClientBillingTiers();
  dispatch(updateTiers(tiers));
  dispatch(setLoadingTiers(false));
}

export const useClientBillingTiers = () => {
  const tierState = useSelector(selectBillingTiers);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!tierState.isLoading && tierState.attempts <= 5) {
      updateBillingTiersData(dispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tierState.isLoading, tierState.attempts]);

  return tierState;
};

export const useGetBillingTierByName = (tier: string) => {
  return useClientBillingTiers().tiers.find((t) => t.tierName === tier);
};
